import { Layout, theme } from "antd";
import HomeTitles from "../components/hometitles/HomeTitles";
import AdminsComponent from "../components/admins/AdminsComponent";
import EmployeesForHome from "../components/employees/EmployeesForHome";
import MeetingsTable from "../components/meetings/MeetingsTable";

const { Content } = Layout;

const Home = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <HomeTitles titleName="GÖRÜŞLƏR" link="/meetings" />
          <MeetingsTable />
          <HomeTitles titleName="ƏMƏKDAŞLAR" link="/employees" />
          <EmployeesForHome />
          <HomeTitles titleName="ADMİNLƏR" link="/admins" />
          <AdminsComponent />
        </div>
      </Content>
    </Layout>
  );
};

export default Home;
